import { useAxiosPrivate } from "./axios";

const ALARM_QUERY = "/alarm/";

export const useGetAlarm = () => {
  const getAlarm = async (callback) => {
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.get(ALARM_QUERY, {
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return getAlarm;
};

export const useRunEmailJob = () => {
  const runEmailJob = async (callback) => {
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.patch(`${ALARM_QUERY}run/email`, {
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return runEmailJob;
};

export const useRunServiceWorksheetJob = () => {
  const runServiceWorksheetJob = async (callback) => {
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.patch(
        `${ALARM_QUERY}run/serviceworksheet`,
        {
          signal: controller.signal,
        },
      );
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return runServiceWorksheetJob;
};

export const useRunOnSiteServiceWorksheetJob = () => {
  const runOnSiteServiceWorksheetJob = async (callback) => {
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.patch(
        `${ALARM_QUERY}run/onsiteserviceworksheet`,
        {
          signal: controller.signal,
        },
      );
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return runOnSiteServiceWorksheetJob;
};
